import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSelectedCategory } from "../../../redux/category";
import { fetchCategoryDishes, clearDishes } from "../../../redux/dish";
import { addItemToCart } from "../../../redux/cart";
import FilterCategoryTab from "./FilterCategoryTab/FilterCategoryTab";
import Cart from "./Cart/Cart";
import Dish from "./Dish/Dish";
import Loader from "../../UI/Loader/Loader";
import classes from "./Dishes.module.scss";
import { useTranslation } from "react-i18next";

const Dishes = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedCategory, categories } = useSelector(
    (state) => state.category
  );
  const { dishes, isLoading, error } = useSelector((state) => state.dish);
  const [filteredCategory, setFilteredCategory] = useState("");

  const onChangeFilter = (newValue) => {
    const foundCategory = categories.find((category) => {
      return category.name === newValue;
    });
    dispatch(setSelectedCategory(foundCategory.id));
  };

  const addDishtoCart = (dish) => {
    dispatch(addItemToCart(dish));
  };

  const fetchDishes = useCallback(() => {
    // if (categories) {
    //   let categoryIds = categories.map((category) => category.id);
    //   dispatch(
    //     fetchAllDishes({
    //       categories: categoryIds,
    //     })
    //   );
    // }
    if (selectedCategory && (!dishes || !dishes[selectedCategory])) {
      dispatch(
        fetchCategoryDishes({
          categoryId: selectedCategory,
        })
      );
    }
  }, [dispatch, selectedCategory, dishes]);

  const updateDishes = useCallback(() => {
    dispatch(clearDishes());
    dispatch(
      fetchCategoryDishes({
        categoryId: selectedCategory,
      })
    );
  }, [dispatch, selectedCategory]);

  useEffect(() => {
    fetchDishes();
  }, [fetchDishes]);

  useEffect(() => {
    if (!categories) {
      return navigate("/home");
    }

    const foundCategory = categories.find((category) => {
      return category.id === +selectedCategory;
    });
    setFilteredCategory(foundCategory.name);
  }, [categories, selectedCategory, navigate]);

  let displayedDishes = null;
  let noDishes = null;
  let errorMessage = null;

  if (
    !isLoading &&
    !error &&
    dishes &&
    dishes[selectedCategory] !== undefined
  ) {
    if (dishes[selectedCategory].length > 0) {
      displayedDishes = (
        <div className={classes.AllDishes}>
          {dishes[selectedCategory].map((dish) => {
            return (
              <Dish
                onClicked={() => addDishtoCart(dish)}
                key={dish.name}
                name={dish.name}
                img={`${process.env.REACT_APP_ASSETS_URL}/storage/${dish.image}`}
                hasImage={dish.image !== "null"}
                price={dish.price}
                stock={dish.amount}
              />
            );
          })}
        </div>
      );
    } else {
      noDishes = (
        <h3>
          {t("NOTF_NO_DISH")} "{filteredCategory}"
        </h3>
      );
    }
  }

  if (
    !isLoading &&
    !error &&
    dishes &&
    dishes[selectedCategory] === undefined
  ) {
    errorMessage = <p className={classes.Error}>{t("NOTF_SOMETHING_WRONG")}</p>;
  }
  if (error) {
    errorMessage = <p className={classes.Error}>{error}</p>;
  }

  return (
    <div className={classes.Dishes}>
      <div className={classes.DishesBox}>
        {categories && (
          <FilterCategoryTab
            categories={categories}
            selectedCategory={filteredCategory}
            onChangeFilter={onChangeFilter}
          />
        )}
        <h2 className={classes.Heading2}>{t("CHOOSE_DISH")}</h2>
        {error && <p className={classes.Error}>{error}</p>}
        {isLoading && <Loader />}
        {displayedDishes}
        {noDishes}
        {errorMessage}
      </div>
      <Cart onClear={updateDishes} />
    </div>
  );
};

export default Dishes;
